export default {"src":"/_next/static/media/people-group.653c3155.svg","height":18,"width":22};